import { Mask } from '@platform-ui/input';

export enum PhoneNumberType {
  mobile = 'mobile', // mask for mobile numbers
  landline = 'landline', // landline phone - the first number after prefix is 2
  combined = 'combined', // landline phone number with the same length as for mobile (после префикса): first number - 1 to 7 OR  first number 8 second - NOT 9
}

export type MaskWithMeta = {
  origin: string;
  instance: Mask;
  meta: {
    placeholder: string;
  };
};

export const phoneMasksWithMetaPh: Record<PhoneNumberType, MaskWithMeta> = {
  [PhoneNumberType.mobile]: {
    origin: '+63 999 999 9999',
    instance: new Mask('+63 999 999 9999'),
    meta: {
      placeholder: '+63 901 234 5678',
    },
  },
  [PhoneNumberType.landline]: {
    origin: '+63 9 9999 9999',
    instance: new Mask('+63 9 9999 9999'),
    meta: {
      placeholder: '+63 2 0123 4567',
    },
  },
  [PhoneNumberType.combined]: {
    origin: '+63 99 999 9999',
    instance: new Mask('+63 99 999 9999'),
    meta: {
      placeholder: '+63 70 123 4567',
    },
  },
};
